import { render, staticRenderFns } from "./GuiasResumenFacturador.vue?vue&type=template&id=4bcfcfe4&scoped=true"
import script from "./GuiasResumenFacturador.vue?vue&type=script&lang=js"
export * from "./GuiasResumenFacturador.vue?vue&type=script&lang=js"
import style0 from "./GuiasResumenFacturador.vue?vue&type=style&index=0&id=4bcfcfe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcfcfe4",
  null
  
)

export default component.exports